import React from "react";
import PropTypes from "prop-types";
import Icon from "components/icon";
import IconButton from "components/icon-button";
import { FormattedMessage } from "react-intl";

const DownloadNotAvailable = ({ showIcon }) => {
  return showIcon ? (
    <IconButton disabled>
      <Icon name="cloud-download" />
    </IconButton>
  ) : (
    <FormattedMessage id="common.download.notAvailable" />
  );
};

DownloadNotAvailable.propTypes = {
  /**
   * Si está activado muestra el icono, si es false muestra un texto
   **/
  showIcon: PropTypes.bool,
};

export default DownloadNotAvailable;
